import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Label, Col, Row, FormGroup, Form} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import DomainInput from "../../../commonComponents/domainInput/DomainInput";

class EditAccreditationRequestsByDomainModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            domain: ''
        }
    }

    componentWillUpdate(nextProps) {
        if (!_.isEqual(this.props.data, nextProps.data) || this.props.isOpen !== nextProps.isOpen) {
            this.setState({domain: nextProps.data ? nextProps.data.value : ''});
        }
    }

    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="accreditation-requests-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <Form>
                {this.renderData()}
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            type="submit"
                            disabled={this.saveButtonDisabled()}
                            onClick={this.handleEdit}>{_.get(this.props.translation, sharedLabelsPath.save_changes_button)}</Button>
                </div>
            </Form>
        );
    }

    saveButtonDisabled = () => {
        return _.isNil(this.props.data) || this.props.data.value === this.state.domain;
    };

    renderData = () => {
        let rowDataParams = {
            key: "requestsNumber",
            title: _.get(this.props.translation, "accreditation_requests.accreditation_requests_number_label") + ":",
            value: this.props.data.amount
        };


        let inputParams = {
            value: "domain",
            title: _.get(this.props.translation, "accreditation_requests.organization_domain_label"),
            isRequired: true
        };

        return [this.getDataRow(rowDataParams), this.getOrganizationDomainFormGroup(inputParams)]
    };

    getOrganizationDomainFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }

        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={6}>{params.title}:</Label>
                <Col>
                    <DomainInput
                           value={this.state[params.value]}
                           onChange={this.handleChangeDomain}
                           placeholder={params.title}
                           required={params.isRequired}/>
                </Col>
            </FormGroup>
        );
    };

    getDataRow = (params) => {
        if (_.isNil(params.value)) {
            return null;
        }

        return (
            <Row className="modal-form-field-container" key={params.key}>
                <Col sm={6}>
                    {params.title}
                </Col>
                <Col>
                    {params.value}
                </Col>
            </Row>
        );
    };

    handleChangeDomain = (data) => {
        this.setState({domain: data});
    };

    handleEdit = (e) => {
        e.preventDefault();

        this.props.onAccreditationRequestsEdit(this.props.data.value, this.state.domain);
        this.props.onCancel();
        this.setState({domain: ''});
    };

    handleCancel = () => {
        this.props.onCancel();
        this.setState({domain: ''});
    };
}

EditAccreditationRequestsByDomainModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onAccreditationRequestsEdit: PropTypes.func,
    onCancel: PropTypes.func
};

export default EditAccreditationRequestsByDomainModal;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationModal/editAccreditationRequestsByDomainModal/EditAccreditationRequestsByDomainModal.js